<template>
  <ife-container>
    <ife-row align-h="center">
      <ife-col
        cols="12"
        md="7"
        lg="5"
        class="mt-4"
      >
        <b-overlay :show="states.login.loading">
          <ife-card title="Login">
            <b-alert
              variant="danger"
              :show="states.login.error !== null"
            >
              {{ states.login.error }}
            </b-alert>

            <validation-observer v-slot="v">
              <ife-form
                :validation-summary="false"
                @submit="v.handleSubmit(login)"
              >
                <ife-simple-input
                  v-model="credentials.email"
                  :label-cols="4"
                  label="Email Address"
                  type="email"
                  rules="required"
                />

                <ife-simple-input
                  v-model="credentials.password"
                  :label-cols="4"
                  label="Password"
                  type="password"
                  rules="required"
                />

                <template #buttons>
                  <b-btn
                    size="sm"
                    variant="primary"
                    type="submit"
                  >
                    Log In
                  </b-btn>
                </template>
              </ife-form>
            </validation-observer>
            <login-links />
          </ife-card>

          <footer class="login-footer">
            <span class="text-muted small">
              By using IFE Data, you are agreeing to and accepting our
              <b-link @click="$bvModal.show('terms-of-service-modal')">Terms of Service</b-link>
              and
              <b-link @click="$bvModal.show('privacy-policy-modal')">Privacy Policy</b-link>.
            </span>
          </footer>

          <terms-of-service-modal />
          <privacy-policy-modal />

          <template #overlay>
            <div class="text-center">
              <b-icon
                icon="shield-lock"
                font-scale="3"
                animation="cylon"
              />
              <p id="label">
                Authenticating
              </p>
            </div>
          </template>
        </b-overlay>
      </ife-col>
    </ife-row>
  </ife-container>
</template>

<script>
import {InitStore} from '@/Client/Store';
import UserPreferences from '@/Client/Model/UserPreferences';
import LoginLinks from '@/Client/Component/Common/LoginLinks.vue';
import PrivacyPolicyModal from '@/Client/Component/Common/PrivacyPolicyModal.vue';
import TermsOfServiceModal from '@/Client/Component/Common/TermsOfServiceModal.vue';

export default {
  name: 'Login',
  components: {
    LoginLinks,
    TermsOfServiceModal,
    PrivacyPolicyModal,
  },
  data() {
    return {
      credentials: {
        email: null,
        password: null,
      },
      states: {
        login: {
          loading: false,
          error: null,
        },
      },
    };
  },
  methods: {
    login() {
      this.states.login.error = null;
      this.states.login.loading = true;
      this.$store.dispatch(
          'login',
          this.credentials,
      ).then(() => {
        InitStore.init(this.axios, this.$store);
        UserPreferences.removeCompanyLogin();

        if (
          this.hasPermission('ROLE_DISTRIBUTOR_PORTAL_USER') &&
          !this.hasPermission('ROLE_APP_USER') &&
          'distributorLanding' !== this.$route.name
        ) {
          this.toastError('You are not authorised to access this site.');
          this.$store.dispatch('logout').then(() => {
            this.$store.commit('resetState');
            this.$store.dispatch('logout');
            this.$router.go();
          });

          return;
        }

        this.routerPush();
      }).catch((error) => {
        this.$log.error(error);
        this.states.login.loading = false;
        this.states.login.error = 'Invalid email or password';
      });
    },

    /**
     * Sends the User to the landing page for their permissions.
     *
     * Logging in does not itself trigger a route change, so without this the User
     * is left on whichever route they were already on (usually the dashboard) and
     * the role-based redirect in the router's beforeEach guard never runs.
     */
    routerPush() {
      let routeName = 'home';

      if (!this.hasPermission('ROLE_NAVIGATION_USER') && this.hasPermission('ROLE_AIRLINE_CLIENT_PORTAL_USER')) {
        routeName = 'airlineClientPortal';
      } else if (this.hasPermission('ROLE_SYSTEMVENDOR_PREVIEW')) {
        routeName = 'airplanePreview';
      } else if (this.hasPermission('ROLE_SHARED_SCREEN_USER')) {
        routeName = 'deliverablesChecklist';
      }

      if (routeName !== this.$route.name) {
        this.$router.push({name: routeName});
      }
    },
  },
};
</script>

<style scoped>
.login-footer {
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 0.4rem 0.75rem;
}
</style>
